import { render, staticRenderFns } from "./ScbEasy_backup_old.vue?vue&type=template&id=f6003ad2&scoped=true"
import script from "./ScbEasy_backup_old.vue?vue&type=script&lang=js"
export * from "./ScbEasy_backup_old.vue?vue&type=script&lang=js"
import style0 from "./ScbEasy_backup_old.vue?vue&type=style&index=0&id=f6003ad2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6003ad2",
  null
  
)

export default component.exports